













import { Component, Prop, Vue } from 'vue-property-decorator';
import Member from '@/models/Member';

@Component
export default class MemberListItem extends Vue {
  @Prop({ required: true }) private member!: Member;

  private isOnline(): boolean {
    return (Date.now() - this.member.updatedAt) <= 60 * 1000;
  }
}
